import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCog, faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons'
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-regular-svg-icons'
import { Button, Dropdown, Menu, Tooltip } from 'antd'
import { useSelector } from 'react-redux'

import { callFunctionIfDefined } from '../../../../utils/functionHelper'
import { isObject } from '../../../../utils'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { getColumnKey } from '../utils'

const { Item, ItemGroup } = Menu

const DEFAULT_OPTIONS = [
  {
    title: '10 lines',
    value: 10,
    type: 'pageSize'
  },
  {
    title: '20 lines',
    value: 20,
    type: 'pageSize'
  },
  {
    title: '50 lines',
    value: 50,
    type: 'pageSize'
  }
]

const TableConfig = ({
  columns, columnsSelector, metadata, options, parameters,
  onParametersChange, onHiddenColumnsChange, onSelect
}) => {
  const t = useSelector(selectTranslate)

  const handleOptionSelect = (value, type) => {
    callFunctionIfDefined(onSelect, [{ value, type }])
  }

  const handleHiddenColumnClick = (column, hidden) => {
    const key = getColumnKey(column)

    const newColumns = !hidden
      ? [...parameters.hiddenColumns, key]
      : parameters.hiddenColumns.filter(k => k !== key)

    onHiddenColumnsChange(newColumns)
  }

  const renderOverlay = () => {
    const displayedOptions = Array.isArray(options) ? options : DEFAULT_OPTIONS
    const menuItems = []

    if (metadata) {
      menuItems.push(
        <ItemGroup key='data_display' title={t('Data displaying')}>
          {displayedOptions.map((o, index) => {
            return (
              <Item
                key={index}
                style={{ textAlign: 'right' }}
                onClick={() => handleOptionSelect(o.value, o.type)}
              >
                {t(o.title)}
                {metadata && metadata[o.type] && metadata[o.type] === o.value && (
                  <FontAwesomeIcon icon={faCheck} />
                )}
              </Item>
            )
          })}
        </ItemGroup>
      )
    }

    if (isObject(parameters) && typeof onParametersChange === 'function') {
      menuItems.push(
        <ItemGroup key='table_parameters' title={t('Table parameters')}>
          <Item
            key='tooltip-parameter'
            style={{ textAlign: 'right' }}
            onClick={() => onParametersChange({ ...parameters, tooltip: !parameters.tooltip })}
          >
            {t('Enable tooltips')}
            <FontAwesomeIcon icon={parameters.tooltip ? faCheckCircle : faTimesCircle} color={parameters.tooltip ? 'green' : 'red'} />
          </Item>
        </ItemGroup>
      )
    }

    if (columnsSelector && Array.isArray(columns) && columns.length > 0) {
      menuItems.push(
        <ItemGroup key='columns_displaying' title={t('Columns displaying')}>
          {columns.map((c, index) => {
            const hidden = parameters.hiddenColumns.includes(getColumnKey(c))

            return (
              <Item
                key={index}
                style={{ textAlign: 'right' }}
                onClick={() => handleHiddenColumnClick(c, hidden)}
              >
                {t(c.title)}
                <FontAwesomeIcon icon={hidden ? faEyeSlash : faEye} />
              </Item>
            )
          })}
        </ItemGroup>
      )
    }

    return menuItems
  }

  return (
    <div className='table-config-container'>
      <Dropdown
        overlay={(
          <Menu>
            {renderOverlay()}
          </Menu>
        )}
        trigger={['click']}
        zIndex={5000}
      >
        <Tooltip title={t('table_config.button_title')} zIndex={5000}>
          <Button>
            <FontAwesomeIcon icon={faCog} />
          </Button>
        </Tooltip>
      </Dropdown>
    </div>
  )
}

export default TableConfig
